import styled from 'styled-components';


export const Container = styled.div`

`
export const Content = styled.main`
    display: flex ;
    
`
export const SectionLeft = styled.section`
    width:50% ;
    padding:10px;

    p{
        cursor:pointer;
        color: #000;
    }
    a{text-decoration:none;}
`

export const AsideRight = styled.aside`
    flex:1;
    box-sizing:border-box ;
    padding: 10px 60px;
    border-left: 1px solid #c3c3c3 ;
`
export const HeaderViewOptionsReports = styled.header`
    display:flex;
    justify-content: flex-end ;
    svg {
        cursor: pointer;
    }

`
